// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation-module--navigation--_yI7y","navigationItem":"navigation-module--navigationItem--1plNx","darkButton":"navigation-module--darkButton--1xy6O"};